import axiosClient from '../axiosClient';
import type { AxiosRequestConfig } from 'axios';

export interface WorklistDetails {
  systemObjectId: number | null;
  databaseObjectId: number;
  tableDefinitionId: number;
  itemName: string;
  dbSchemaName: string;
  dbViewName: string;
  icsExternalId: string;
  dbTableName: string;
  dbObjectName: string;
  columns: WorklistColumn[];
  sql?: string;
  viewExists: boolean;
  active: boolean;
  description?: string;
  systemObjectName?: string;
  systemObjectPath?: string;
  hasViewError?: boolean;
  viewErrorMessage?: string;
}

export interface WorklistColumn {
  databaseObjectId: number;
  databaseObjectColumnId: number;
  showInList: boolean;
  showInDetail: boolean;
  includeInExport: boolean;
  includeInputFormNew?: boolean | null;
  dbColumnName: string;
  columnLabel: string;
  columnWidth: number;
  componentEditId: number;
  componentEdit: string;
  valueListId?: number;
  simpleListOfValue?: string;
  simpleListOfValueSeparator?: string;
  listOfValueObjectId?: number;
  ordinal: number;
  orderByOrdinal?: number;
  orderBy?: string;
  numberFormatShowThousandsSeparator?: boolean;
  numberFormatDecimalPrecision?: number;
  isSystemColumn: boolean;
  isReadOnly: boolean;
  systemColumn?: {
    columnName: string;
    baseDataType?: string | null;
    maxLength?: number;
    isNullable?: boolean;
    precision?: number;
    scale?: number;
    isReadOnly?: boolean;
    isUpdateable?: boolean;
    systemTypeName?: string | null;
  };
  tableDefinitionColumn?: any;
  columnType?: 'systemColumn' | 'tableColumn' | 'viewOnlyColumn'; // ViewColumnType fra backend (lowercase i JSON)
  viewColumnType?: 'systemColumn' | 'tableColumn' | 'viewOnlyColumn'; // ViewColumnType fra backend (alternativ property)
  allowedComponentEdits?: Array<{ value: string; label: string }>;
  componentEditLabel?: string;
  isReadOnlyEditable?: boolean | null;
  nullHandling?: 'allow' | 'required' | 'default' | null;
  hasSqlFunction?: boolean;
  isUpdateable?: boolean;
}

export async function getWorklistDetails (
  databaseObjectId: number,
  signal?: AbortSignal
): Promise<WorklistDetails> {
  const config: AxiosRequestConfig = {
    signal
  };

  const response = await axiosClient.get(`v2/database/object/${databaseObjectId}`, config);
  return response.data;
}
